var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoneFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1826C12.0869 15.1826 15.4707 11.7915 15.4707 7.71191C15.4707 3.625 12.0796 0.241211 7.99268 0.241211C3.91309 0.241211 0.529297 3.625 0.529297 7.71191C0.529297 11.7915 3.92041 15.1826 8 15.1826ZM7.17236 11.2935C6.92334 11.2935 6.71826 11.1909 6.52783 10.9346L4.68945 8.67871C4.57959 8.53223 4.51367 8.37109 4.51367 8.20264C4.51367 7.87305 4.77002 7.60205 5.09961 7.60205C5.31201 7.60205 5.47314 7.66797 5.65625 7.90967L7.14307 9.82861L10.2705 4.8042C10.4097 4.58447 10.6001 4.46729 10.7905 4.46729C11.1128 4.46729 11.4131 4.68701 11.4131 5.03125C11.4131 5.19238 11.3179 5.36084 11.23 5.51465L7.7876 10.9346C7.63379 11.1763 7.42139 11.2935 7.17236 11.2935Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoneFilled);
export default __webpack_public_path__ + "static/media/icon-done-filled.c14113150ccc80e75d345f0e62d4ac3f.svg";
export { ForwardRef as ReactComponent };